import React, { createContext, useState, useEffect, useCallback } from "react";

export const Authcontext = createContext();

const AuthContextProvider = ({ children }) => {
  const getInitialAuthState = () => {
    try {
      const raw = localStorage.getItem("loginCheck");
      const token = localStorage.getItem("token");
      const uid = localStorage.getItem("uid");
      const isCheckTrue = raw === "true" || raw === true;
      const cleanToken = token !== null && token !== undefined ? String(token).trim() : "";
      const cleanUid = uid !== null && uid !== undefined ? String(uid).trim() : "";
      return Boolean(isCheckTrue && cleanToken !== "" && cleanUid !== "" && cleanUid !== "null");
    } catch (e) {
      return false;
    }
  };

  const [correct, setCorrectState] = useState(getInitialAuthState);

  const setCorrect = (val) => {
    const boolVal = Boolean(val);
    setCorrectState(boolVal);
    localStorage.setItem("loginCheck", JSON.stringify(boolVal));
  };

  // Sync state across window/tabs
  useEffect(() => {
    const handleStorageChange = () => {
      setCorrectState(getInitialAuthState());
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const logout = useCallback(() => {
    // Clear all auth and session keys from localStorage
    localStorage.removeItem("loginCheck");
    localStorage.removeItem("token");
    localStorage.removeItem("uid");
    localStorage.removeItem("loginsetName");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("username");
    localStorage.removeItem("name");
    localStorage.removeItem("orderpageData");
    localStorage.removeItem("order_id");
    localStorage.removeItem("cids");
    localStorage.removeItem("subcatname");
    localStorage.removeItem("maincatname");
    localStorage.removeItem("selectedLanguage");

    // Clear session cookies
    document.cookie = "username=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

    // Update React auth state
    setCorrectState(false);
  }, []);

  const login = useCallback((userData) => {
    if (!userData) return;
    localStorage.setItem("loginCheck", "true");
    if (userData.token) localStorage.setItem("token", String(userData.token));
    if (userData.uid !== undefined && userData.uid !== null) localStorage.setItem("uid", String(userData.uid));
    if (userData.name) localStorage.setItem("loginsetName", String(userData.name));
    if (userData.role) localStorage.setItem("role", String(userData.role));
    if (userData.email || userData.username) {
      localStorage.setItem("email", String(userData.email || userData.username));
    }
    setCorrectState(true);
  }, []);

  return (
    <Authcontext.Provider value={{ correct, setCorrect, logout, login }}>
      {children}
    </Authcontext.Provider>
  );
};

export default AuthContextProvider;